// extracted by mini-css-extract-plugin
export default {"preloader-wrapper":"preloader-wrapper--vWJtT","preloaderWrapper":"preloader-wrapper--vWJtT","loader-content":"loader-content--ssJlJ","loaderContent":"loader-content--ssJlJ"};